{
  "ui": {
    "close": "Закрыть",
    "cancel": "Отмена",
    "save": "Сохранить",
    "edit": "Изменить",
    "delete": "Удалить",
    "add": "Добавить",
    "more": "Ещё",
    "retry": "Повторить",
    "showMore": "Показать ещё",
    "done": "Готово",
    "password": {
      "show": "Показать пароль",
      "hide": "Скрыть пароль"
    }
  },
  "preferences": {
    "language": "Язык"
  },
  "app": {
    "crash": {
      "title": "Что-то пошло не так",
      "description": "Страница не загрузилась до конца. Обновите её — обычно это помогает.",
      "home": "На главную"
    }
  },
  "notFound": {
    "title": "Такой страницы нет",
    "description": "Возможно, ссылка устарела или в ней опечатка.",
    "home": "На главную"
  },
  "home": {
    "title": "Вход на сеанс — по приглашению",
    "description": "Откройте ссылку, которую прислал ведущий: по ней вы попадёте в зал.",
    "hostSignIn": "Я ведущий — войти"
  },
  "auth": {
    "login": "Логин",
    "password": "Пароль",
    "signIn": "Войти",
    "signInTitle": "Вход для ведущих",
    "signOut": "Выйти",
    "displayName": "Имя для зрителей",
    "newPassword": "Придумайте пароль",
    "welcome": {
      "title": "Добро пожаловать в Seans",
      "expires": "Ссылка действует до {{date}}",
      "submit": "Создать аккаунт",
      "invalid": "Ссылка-приглашение не работает",
      "invalidHint": "Она уже использована или истекла. Попросите владельца прислать новую."
    }
  },
  "validation": {
    "required": "Заполните это поле",
    "login": "От 3 до 32 символов: латинские буквы, цифры, точка, дефис, подчёркивание",
    "password": "Не короче 10 символов",
    "displayName": "От 1 до 40 символов",
    "title": "От 1 до 120 символов",
    "trackLabel": "Не длиннее 60 символов"
  },
  "roles": {
    "account": {
      "owner": "Владелец",
      "host": "Ведущий"
    },
    "participant": {
      "host": "Ведущий",
      "guest": "Зритель"
    }
  },
  "errors": {
    "unauthenticated": "Сессия закончилась. Войдите снова.",
    "forbidden": "На это нет прав.",
    "not_found": "Не нашли — возможно, это уже удалили.",
    "validation_failed": "Проверьте введённые данные.",
    "rate_limited": "Слишком много попыток. Подождите немного и попробуйте снова.",
    "credentials_invalid": "Неверный логин или пароль.",
    "account_disabled": "Доступ к этому аккаунту отключён. Обратитесь к владельцу.",
    "login_taken": "Этот логин уже занят.",
    "invitation_invalid": "Ссылка-приглашение недействительна или истекла.",
    "invite_invalid": "Ссылка на сеанс недействительна. Попросите у ведущего новую.",
    "screening_ended": "Сеанс уже закончился.",
    "participant_banned": "Ведущий закрыл вам доступ к этому сеансу.",
    "playback_version_conflict": "Кто-то только что управлял фильмом — показываем актуальное состояние.",
    "asset_not_ready": "Фильм ещё обрабатывается.",
    "asset_in_use": "Фильм идёт в открытых сеансах — сначала завершите их.",
    "track_not_deletable": "Эту дорожку нельзя удалить.",
    "upload_too_large": "Файл слишком большой.",
    "unsupported_subtitle_format": "Нужен файл субтитров SRT, VTT или ASS.",
    "realtime_unavailable": "Видеосвязь сейчас недоступна. Попробуйте через минуту.",
    "internal": "Ошибка на сервере. Попробуйте ещё раз.",
    "network": "Нет связи с сервером. Проверьте интернет.",
    "timeout": "Сервер долго не отвечает. Попробуйте ещё раз.",
    "invalid_response": "Сервер ответил неожиданно. Обновите страницу.",
    "admission_pending": "Ведущий ещё не впустил вас в зал.",
    "admission_denied": "Просьба о входе отклонена.",
    "admission_decision_conflict": "По этой просьбе уже решили — список обновлён.",
    "unsupported_image_format": "Нужно изображение JPEG, PNG или WebP."
  },
  "studio": {
    "home": "Seans — студия",
    "account": "Аккаунт: {{name}}",
    "nav": {
      "label": "Разделы студии",
      "screenings": "Сеансы",
      "library": "Фильмы",
      "hosts": "Ведущие"
    },
    "profile": {
      "menu": "Профиль",
      "title": "Профиль",
      "name": "Имя для зрителей",
      "nameHint": "Гости увидят новое имя, когда в следующий раз войдут в зал или обновят страницу.",
      "saved": "Имя сохранено"
    }
  },
  "screenings": {
    "create": "Новый сеанс",
    "created": "Сеанс создан",
    "saved": "Изменения сохранены",
    "filter": "Какие сеансы показать",
    "filters": {
      "open": "Предстоящие",
      "ended": "Завершённые"
    },
    "status": {
      "ended": "Завершён"
    },
    "openRoom": "Открыть зал",
    "copyLink": "Скопировать ссылку",
    "linkCopied": "Ссылка скопирована",
    "empty": {
      "open": "Сеансов пока нет",
      "ended": "Завершённых сеансов нет",
      "noFilms": "Сначала добавьте фильм"
    },
    "policy": {
      "hosts": "Только ведущие",
      "everyone": "Все участники"
    },
    "form": {
      "createTitle": "Новый сеанс",
      "editTitle": "Сеанс",
      "create": "Создать",
      "film": "Фильм",
      "filmPlaceholder": "Выберите фильм",
      "filmRequired": "Выберите фильм",
      "filmChangeResets": "Фильм начнётся сначала, на паузе",
      "title": "Название",
      "titlePlaceholder": "Как у фильма",
      "startsAt": "Начало",
      "startsAtRequired": "Укажите дату и время",
      "control": "Кто управляет фильмом",
      "approval": "Впускать после одобрения",
      "approvalOn": "Гости ждут, пока вы их впустите.",
      "approvalOff": "Любой со ссылкой входит сразу.",
      "approvalOffLetsIn": "Ожидающие ({{count}}) войдут сразу после сохранения."
    },
    "rotate": {
      "action": "Новая ссылка",
      "title": "Заменить ссылку-приглашение?",
      "consequence": "Старая ссылка перестанет работать. Кто уже в зале, останется в нём.",
      "confirm": "Заменить",
      "done": "Ссылка заменена — отправьте новую"
    },
    "end": {
      "action": "Завершить сеанс",
      "title": "Завершить «{{title}}»?",
      "consequence": "Зал закроется для всех: связь и фильм остановятся, войти по ссылке будет нельзя. Отменить нельзя.",
      "confirm": "Завершить",
      "done": "Сеанс завершён"
    },
    "delete": {
      "title": "Удалить «{{title}}»?",
      "consequence": "Сеанс и его чат удалятся навсегда, ссылка перестанет работать.",
      "confirm": "Удалить",
      "done": "Сеанс удалён"
    }
  },
  "library": {
    "add": "Добавить фильм",
    "empty": "В библиотеке пока нет фильмов",
    "title": "Название",
    "resolution": "{{height}}p",
    "status": {
      "awaiting_upload": "Ждёт файл",
      "queued": "В очереди",
      "processing": "Обработка",
      "ready": "Готов",
      "failed": "Ошибка",
      "withPercent": "{{status}} · {{percent}}%"
    },
    "upload": {
      "start": "Загрузить",
      "started": "«{{title}}» загружается",
      "pick": "Выберите видеофайл или перетащите его сюда",
      "pickHint": "MKV, MP4, AVI, MOV — любого размера",
      "fileRequired": "Выберите файл",
      "amount": "{{sent}} из {{total}}",
      "uploading": "Загрузка · {{percent}}%",
      "paused": "Пауза",
      "failed": "Связь прервалась",
      "pause": "Приостановить",
      "resume": "Продолжить",
      "cancel": "Отменить загрузку",
      "cancelTitle": "Отменить загрузку?",
      "cancelConsequence": "Фильм «{{title}}» и уже отправленная часть файла будут удалены.",
      "cancelConfirm": "Отменить загрузку",
      "continue": "Продолжить",
      "continueTitle": "Продолжить загрузку «{{title}}»",
      "pickAgain": "Выберите тот же файл: {{filename}}",
      "wrongFile": "Это другой файл. Нужен {{filename}}"
    },
    "failure": {
      "upload_incomplete": "Файл загрузился не полностью.",
      "probe_failed": "Не удалось прочитать файл — возможно, он повреждён.",
      "no_video_stream": "В файле нет видео.",
      "transcode_failed": "Не удалось обработать видео.",
      "subtitle_unsupported": "Этот формат субтитров не поддерживается.",
      "subtitle_convert_failed": "Не удалось прочитать субтитры."
    }
  },
  "asset": {
    "quality": "Качество",
    "noRenditions": "Появится после обработки",
    "duration": "Длительность",
    "resolution": "Разрешение",
    "size": "Размер файла",
    "added": "Добавлен",
    "file": "Исходный файл",
    "rename": "Переименовать",
    "renamed": "Название сохранено",
    "deleteBlocked_one": "Удалить нельзя: фильм в {{count}} сеансе",
    "deleteBlocked_few": "Удалить нельзя: фильм в {{count}} сеансах",
    "deleteBlocked_many": "Удалить нельзя: фильм в {{count}} сеансах",
    "deleteBlocked_other": "Удалить нельзя: фильм в {{count}} сеанса",
    "usedBy": "Идёт в сеансах: {{titles}}",
    "missing": "Фильм не найден",
    "delete": {
      "title": "Удалить «{{title}}»?",
      "consequence": "Фильм, его дорожки и обработанные файлы удалятся навсегда.",
      "done": "Фильм удалён"
    },
    "poster": {
      "change": "Сменить постер",
      "dialogTitle": "Новый постер",
      "preview": "Предпросмотр постера",
      "pick": "Выберите изображение или перетащите его сюда",
      "formats": "{{formats}} · до {{size}}",
      "tooLarge": "Изображение больше {{size}}.",
      "save": "Сохранить постер",
      "saved": "Постер изменён",
      "reset": "Вернуть кадр из фильма",
      "resetTitle": "Вернуть кадр из фильма?",
      "resetConsequence": "Ваш постер исчезнет, и везде — в студии, приглашениях и в зале — снова будет кадр из самого фильма.",
      "resetConfirm": "Вернуть кадр",
      "resetDone": "Кадр из фильма снова на месте",
      "source": {
        "frame": "Кадр из фильма",
        "upload": "Свой постер"
      }
    }
  },
  "tracks": {
    "numbered": "Дорожка {{number}}",
    "language": "Язык",
    "languageUnset": "Не указан",
    "label": "Название",
    "labelOptional": "Название (необязательно)",
    "default": "По умолчанию",
    "defaultHint": "Включается у зрителей сама",
    "saved": "Дорожка сохранена",
    "kind": {
      "audio": "Звуковые дорожки",
      "subtitle": "Субтитры"
    },
    "empty": {
      "audio": "В фильме нет звука",
      "subtitle": "Субтитров пока нет"
    },
    "status": {
      "processing": "Обработка",
      "ready": "Готово",
      "failed": "Ошибка"
    },
    "delete": {
      "title": "Удалить «{{name}}»?",
      "consequence": "Зрители больше не смогут выбрать эти субтитры.",
      "done": "Субтитры удалены"
    },
    "upload": {
      "title": "Добавить субтитры",
      "submit": "Загрузить",
      "pick": "Выберите файл субтитров",
      "formats": "{{formats}} · до {{size}}, любая кодировка",
      "fileRequired": "Выберите файл",
      "tooLarge": "Файл больше {{size}}",
      "done": "Субтитры загружены — обрабатываем"
    }
  },
  "hosts": {
    "empty": "Ведущих пока нет",
    "you": "это вы",
    "disabled": "Доступ отключён",
    "since": "с {{date}}",
    "noAccess": "Этот раздел — только для владельца",
    "noAccessHint": "Ведущих приглашает и отключает владелец студии.",
    "access": {
      "label": "Доступ",
      "revoke": "Отключить",
      "revoked": "{{name}} больше не может войти",
      "restored": "{{name}} снова может войти",
      "revokeTitle": "Отключить доступ для {{name}}?",
      "revokeConsequence": "{{name}} выйдет из студии и не сможет войти, пока вы не включите доступ снова. Сеансы и фильмы останутся."
    },
    "invite": {
      "action": "Пригласить",
      "title": "Пригласить ведущего",
      "role": "Роль",
      "create": "Создать ссылку",
      "link": "Ссылка-приглашение",
      "expires": "Одноразовая, действует до {{date}}",
      "copy": "Скопировать",
      "copied": "Ссылка скопирована",
      "copyFailed": "Не удалось скопировать — выделите ссылку вручную"
    }
  },
  "invite": {
    "eyebrow": "Приглашение на сеанс",
    "name": "Как вас представить",
    "continue": "Продолжить",
    "asHost": "Вы войдёте как ведущий — {{name}}",
    "ended": "Этот сеанс уже закончился.",
    "bannedBadge": "Доступ закрыт",
    "invalid": "Ссылка на сеанс не работает",
    "invalidHint": "Возможно, ведущий заменил ссылку. Попросите у него новую.",
    "askToJoin": "Попросить войти"
  },
  "lobby": {
    "eyebrow": "Проверка перед входом",
    "preview": "Предпросмотр камеры",
    "join": "Войти в зал",
    "headphones": "В наушниках звук фильма не попадёт в ваш микрофон.",
    "micLevel": "Громкость микрофона",
    "deviceNumbered": "Устройство {{number}}",
    "device": {
      "camera": "Камера",
      "microphone": "Микрофон",
      "speaker": "Динамики"
    },
    "problem": {
      "denied": "Браузер запретил доступ: {{device}}",
      "notFound": "Не нашли устройство: {{device}}. Подключите его и нажмите «Повторить».",
      "inUse": "{{device}} занят(а) другой программой (Zoom, Teams, другая вкладка). Закройте её и нажмите «Повторить».",
      "insecure": "Камера и микрофон работают только по защищённой ссылке (https).",
      "unsupported": "Этот браузер не умеет работать с камерой и микрофоном. Откройте ссылку в Chrome, Safari или Firefox.",
      "unknown": "Не удалось включить: {{device}}. Нажмите «Повторить»."
    },
    "guide": {
      "chrome": "Нажмите на значок настроек слева от адреса сайта, включите «Камера» и «Микрофон» и нажмите «Повторить».",
      "edge": "Нажмите на значок замка слева от адреса, откройте «Разрешения для этого сайта», разрешите камеру и микрофон и нажмите «Повторить».",
      "yandex": "Нажмите на значок замка в адресной строке, разрешите камеру и микрофон и нажмите «Повторить».",
      "opera": "Нажмите на значок замка в адресной строке, разрешите камеру и микрофон и нажмите «Повторить».",
      "samsung": "Откройте меню → «Настройки» → «Сайты и загрузки» → «Разрешения сайтов», разрешите камеру и микрофон и нажмите «Повторить».",
      "firefox": "Нажмите на перечёркнутый значок камеры в адресной строке, снимите блокировку и нажмите «Повторить».",
      "safari": "Откройте Safari → «Настройки для этого веб-сайта», выберите «Разрешить» для камеры и микрофона и нажмите «Повторить».",
      "safariIos": "Нажмите «аА» в адресной строке → «Настройки веб-сайта», разрешите камеру и микрофон и нажмите «Повторить».",
      "other": "Разрешите сайту доступ к камере и микрофону в настройках браузера и нажмите «Повторить»."
    }
  },
  "call": {
    "mic": {
      "on": "Включить микрофон",
      "off": "Выключить микрофон",
      "onWithHold": "Включить микрофон (или удерживайте пробел)",
      "isOff": "Микрофон выключен"
    },
    "camera": {
      "on": "Включить камеру",
      "off": "Выключить камеру",
      "isOn": "Камера включена"
    },
    "settings": "Устройства и звук",
    "deviceProblem": "Устройство недоступно",
    "pushToTalk": "Говорить, удерживая пробел",
    "pushToTalkHint": "Когда микрофон выключен",
    "you": "{{name}} (вы)",
    "participants": "Участники",
    "sync": {
      "idle": "Не смотрит",
      "synced": "Смотрит синхронно",
      "catching_up": "Догоняет",
      "buffering": "Загружается"
    }
  },
  "player": {
    "label": "Фильм",
    "notReady": "Фильм ещё готовится",
    "timeline": "Позиция в фильме",
    "timeOf": "{{position}} из {{duration}}",
    "mute": "Выключить звук",
    "unmute": "Включить звук",
    "volume": "Громкость",
    "settings": "Настройки просмотра",
    "subtitles": "Субтитры",
    "subtitlesOff": "Выключены",
    "audio": "Звуковая дорожка",
    "quality": "Качество",
    "qualityAuto": "Авто",
    "qualityAutoAt": "Авто · {{height}}p",
    "ducking": "Приглушать фильм, когда говорят",
    "duckingHint": "Только у вас",
    "joinPlayback": "Включить фильм и звук",
    "loadFailed": "Фильм не загружается.",
    "fullscreen": "Во весь экран",
    "exitFullscreen": "Выйти из полноэкранного режима",
    "play": "Смотреть",
    "pause": "Пауза",
    "hostControls": "Фильмом управляет ведущий",
    "start": "Начать показ",
    "startsOn": "Начало {{date}}",
    "startsIn": "Начало через {{time}}",
    "waitingForHost": "Скоро начнём — ждём ведущего",
    "poster": "Постер фильма"
  },
  "moderation": {
    "menu": "Действия: {{name}}",
    "muteMicrophone": "Выключить микрофон",
    "muteCamera": "Выключить камеру",
    "remove": "Удалить из зала",
    "ban": "Удалить и закрыть доступ",
    "muted": {
      "microphone": "Микрофон {{name}} выключен",
      "camera": "Камера {{name}} выключена"
    },
    "removed": "{{name}} больше нет в зале",
    "removeTitle": "Удалить {{name}} из зала?",
    "removeConsequence": "{{name}} покинет зал. Вернуться можно по ссылке-приглашению.",
    "removeConfirm": "Удалить",
    "banTitle": "Удалить {{name}} и закрыть доступ?",
    "banConsequence": "{{name}} покинет зал и не сможет вернуться на этот сеанс, даже по ссылке.",
    "banConfirm": "Удалить и закрыть"
  },
  "chat": {
    "label": "Сообщения",
    "older": "Показать раньше",
    "empty": "Сообщений пока нет — начните разговор",
    "you": "Вы",
    "sending": "отправляется…",
    "failed": "не отправлено",
    "retry": "Отправить ещё раз",
    "discard": "Убрать",
    "message": "Сообщение",
    "placeholder": "Сообщение для зала",
    "send": "Отправить"
  },
  "room": {
    "count_one": "{{count}} участник",
    "count_few": "{{count}} участника",
    "count_many": "{{count}} участников",
    "count_other": "{{count}} участника",
    "leave": "Выйти из зала",
    "panel": {
      "label": "Чат и участники",
      "chat": "Чат",
      "people": "Люди · {{count}}",
      "hide": "Скрыть чат",
      "show": "Показать чат"
    },
    "connection": {
      "connecting": "Подключаемся…",
      "reconnecting": "Переподключаемся…",
      "unavailable": "Нет связи"
    },
    "closed": {
      "toInvite": "К приглашению",
      "ended": {
        "title": "Сеанс завершён",
        "description": "Спасибо, что смотрели вместе с нами.",
        "action": "К приглашению"
      },
      "removed": {
        "title": "Вас удалили из зала",
        "description": "Вернуться можно по той же ссылке.",
        "action": "Вернуться в зал"
      },
      "banned": {
        "title": "Доступ к сеансу закрыт",
        "description": "Ведущий закрыл вам вход на этот сеанс.",
        "action": "К приглашению"
      },
      "left": {
        "title": "Вы вышли из зала",
        "description": "Фильм продолжается без вас — можно вернуться в любой момент.",
        "action": "Вернуться в зал"
      },
      "replaced": {
        "title": "Сеанс открыт в другой вкладке",
        "description": "Здесь мы его закрыли, чтобы звук не двоился.",
        "action": "Смотреть здесь"
      },
      "denied": {
        "title": "Просьба о входе отклонена",
        "description": "Если это ошибка, напишите ведущему и проверьте ещё раз.",
        "action": "Проверить ещё раз"
      }
    }
  },
  "admission": {
    "welcome": "Ведущий впустил вас — входим в зал",
    "waitingEyebrow": "Ожидание входа",
    "waitingTitle": "Ждём, пока ведущий вас впустит",
    "waitingHint": "Ведущий видит вашу просьбу. Когда он её примет, вы войдёте в зал сами — пока можно проверить камеру и микрофон.",
    "waitingSection": "Хотят войти",
    "refusedSection": "Отклонены",
    "admit": "Впустить: {{name}}",
    "admitShort": "Впустить",
    "deny": "Отклонить: {{name}}",
    "deniedBy": "Отклонено: {{name}} · {{when}}",
    "requested": "{{name}} хочет войти",
    "dialogTitle": "Просьбы о входе",
    "nobody": "Никто не ждёт входа",
    "waitingCount": "Ждут входа: {{count}}"
  }
}
